(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kaos-filter-toolbar"] && !Shopify.designMode) return;
  try {
    if (!document.documentElement.hasAttribute('data-kaos-collection-filter-enhancements')) {
    document.documentElement.setAttribute('data-kaos-collection-filter-enhancements', 'true');
    let pendingKaosCollectionFilterScrollPosition = null;

    const holdKaosCollectionFilterScrollPosition = (scrollLeft, scrollTop) => {
      const holdUntil = performance.now() + 2500;

      const restorePosition = () => {
        window.scrollTo(scrollLeft, scrollTop);

        if (performance.now() < holdUntil) {
          requestAnimationFrame(restorePosition);
        }
      };

      requestAnimationFrame(restorePosition);
    };

    document.addEventListener('pointerdown', (event) => {
      const control = event.target instanceof Element ? event.target.closest('.kaos-filter-toolbar') : null;

      if (!control) return;

      pendingKaosCollectionFilterScrollPosition = {
        left: window.scrollX,
        top: window.scrollY,
        capturedAt: performance.now()
      };
    }, true);

    document.addEventListener('change', (event) => {
      const input = event.target;
      const toolbar = input instanceof Element ? input.closest('.kaos-filter-toolbar') : null;

      if (!toolbar) return;

      const pointerPositionIsCurrent = pendingKaosCollectionFilterScrollPosition
        && performance.now() - pendingKaosCollectionFilterScrollPosition.capturedAt < 2000;
      const scrollLeft = pointerPositionIsCurrent ? pendingKaosCollectionFilterScrollPosition.left : window.scrollX;
      const scrollTop = pointerPositionIsCurrent ? pendingKaosCollectionFilterScrollPosition.top : window.scrollY;

      pendingKaosCollectionFilterScrollPosition = null;

      if (input instanceof HTMLInputElement && input.name === 'filter.p.vendor') {
        input.closest('details.kaos-filter-control')?.removeAttribute('open');
      }

      holdKaosCollectionFilterScrollPosition(scrollLeft, scrollTop);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
